import { FC } from 'react'
import dynamic from 'next/dynamic'
import { reduceListingTags, getTagsFromCategory } from 'lib/listing'
import useMap from 'hooks/useMap'
import { IconCircleCheck } from 'icons'
import SectionHeader from 'components/SectionHeader'
import Button from 'components/Button'
import FeatureItem from 'components/FeatureItem'
import { Tag } from 'graphql/types'
import {
  condominiumTagsButtonEvent,
  condominiumTagsCloseModalEvent,
} from '../../../events'
import styles from './Tags.module.scss'
import regionStyles from 'pages/regioes-atendidas/regiao/Region.module.scss'

type TProps = {
  tags: Array<Tag>
}

const TagsModal = dynamic(() => import('./components/TagsModal'))

const Tags: FC<TProps> = ({ tags }) => {
  const [modalMap, { setAll: setAllAboutModal }] = useMap({
    isMounted: false,
    isVisible: false,
  })
  const listingTags = tags?.reduce(reduceListingTags, [])
  const infrastructureTags = getTagsFromCategory('infrastructure', listingTags)

  return (
    <div className={regionStyles.ecPageRegionSection}>
      <SectionHeader
        title={{
          value: 'Infraestrutura',
        }}
      />
      <div className={styles.ecCondominiumTags}>
        {infrastructureTags.map(
          (tag) =>
            tag?.name && (
              <FeatureItem
                key={tag?.name}
                title={tag?.name}
                Icon={{
                  Component: IconCircleCheck,
                  title: 'Ícone: simbolo de afirmação',
                }}
              />
            ),
        )}
      </div>
      <Button
        className={styles.ecTagsButton}
        onClick={() => {
          condominiumTagsButtonEvent()
          setAllAboutModal({ isMounted: true, isVisible: true })
        }}
      >
        Ver itens não disponíveis
      </Button>
      {modalMap.isMounted && (
        <TagsModal
          tags={tags}
          isVisible={modalMap.isVisible}
          onClose={() => {
            condominiumTagsCloseModalEvent()
            setAllAboutModal({ isMounted: true, isVisible: false })
          }}
        />
      )}
    </div>
  )
}

export default Tags
